<script lang="ts" setup>
const { t } = useI18n();
const { clientUrl } = useRuntimeConfig().public;
const route = useRoute();
const isModalShareOpen = ref(false);

const getSharePath = () => {
  let fullPath = route.fullPath;
  if (fullPath.includes("user-portal/collection")) {
    fullPath = fullPath.replace("user-portal/collection", "collectible");
  }
  return clientUrl + fullPath;
};

const openShare = async () => {
  if (isMobileDevice() && navigator.share) {
    await navigator.share({
      title: t("main.cardCollectible.share"),
      text: "Check out this GFAL Collectible",
      url: getSharePath(),
    });
  } else {
    isModalShareOpen.value = true;
  }
};
</script>

<template>
  <div
    @click="openShare"
    class="absolute top-4 right-4 flex items-center gap-2 text-secondary-200 hover:text-primary-500 transition-all duration-300 cursor-pointer">
    <NuxtIcon name="mdi:share-variant" class="w-4 h-4 cursor-pointer" />
    <p>{{ $t("main.cardCollectible.share") }}</p>
  </div>
  <LazyModalShare v-if="isModalShareOpen" @close="isModalShareOpen = false" />
</template>
